import React from "react";
import { AuthProvider } from "./AuthContext";
import { CartProvider } from "./CartContext";

export default function AppProvider({ children }) {
  return (
    <AuthProvider>
      <CartProvider>{children}</CartProvider>
    </AuthProvider>
  );
}
